import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { Constants } from '../core/constants';

@Injectable()
export class RecurringDepositAccountService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private constants: Constants, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'recurringdepositaccount/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAll(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `recurringdepositaccount?isMaintenance=${forMaintenance}`).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `recurringdepositaccount/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createWithTransactions(recurringDepositAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'recurringdepositaccount', recurringDepositAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(recurringDepositAccount: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'recurringdepositaccount', recurringDepositAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'recurringdepositaccount/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `recurringdepositaccount/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computeInstallments(recurringDepositInstallmentData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'recurringdepositaccount/notionalinterest', recurringDepositInstallmentData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computeClosureData(accountId: number, completedDays: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `recurringdepositaccount/closure/${accountId}?completedDays=${completedDays}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAllRDAccountsByAccountId(accountId: number,generalLedgerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `recurringdepositaccount/id/${accountId}?generalLedgerId=${generalLedgerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  recurringDepositSaveCollection(collectionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + `recurringdepositaccount/collection`, collectionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  closeAccount(closureData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'recurringdepositaccount/closure', closureData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
